import { theme } from '~/theme';

export const useSxStyles = () => {
  return {
    dialogPaper: {
      maxWidth: '900px',
    },
    formErrorMessage: {
      marginRight: theme.spacing(1),
    },
    selectStyle: {
      width: '100%',
    },
    dateInput: {
      width: '100%',
    },
    vacBalContainer: {
      display: 'flex',
      alignItems: 'center',
      paddingTop: 0.5,
    },
    radioLabel: {
      fontSize: '13px',
      fontWeight: 'bold',
    },
    btnLeftMargin: {
      marginLeft: '5px',
    },
    warningMessage: {
      color: '#ff3300',
    },
    inputBottomMargin: {
      marginBottom: theme.spacing(2.5),
    },
    clearBtn: {
      marginLeft: theme.spacing(),
      marginBottom: theme.spacing(2.5),
    },
  };
};
